export default Object.freeze({
  UNSET: 0,
  GENERATE_INFORM: 1,
  MORE_INFORMATION: 2,
  SHARE: 3,
  TAG: 4,
  RELATED: 5
});
